<template>
  <div class="logins-wrapper">
     <div class="header" >
      <img src="../assets/img/zflogo.png" alt="" class="zf-logo">
      <div class="header-right">
        <p></p>
       <a href="http://demo.csz.emof.cn/web/" ><img src="../assets/img/hname.png" alt="" ></a>
        <!-- <a href="javascript:void 0" ><img src="../assets/img/hname.png" alt="" @click="tips"></a> -->
      </div>
    </div>
    <div class="login-box">
      <h2>
        <img src="../assets/img/login-logo.png" alt="">
      </h2>
      <div class="login-info">
        <div class="login-type">
          <h3>忘记密码</h3>
        </div>
        <div>
          <div class="set-account">
            <div class="login-input flex-center">
              <i>机构名称</i>
              <el-input v-model="account" placeholder="请输入机构名称" class="login-item"></el-input>
            </div>
            <div class="login-input flex-center">
              <i>手机号</i>
              <el-input v-model="phone" placeholder="请输入手机号" class="login-item"></el-input>
            </div>
            <div class="login-input flex-center">
              <i>验证码</i>
              <el-input v-model="smsCode" placeholder="请输入验证码" class="login-item"></el-input>
              <div class="code-text" @click="sendCode">
                {{codeText}} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
              </div>
            </div>
            <div class="login-input flex-center">
              <i>新密码</i>
              <el-input type="password" v-model="newPass" placeholder="请输入新密码" class="login-item"></el-input>
            </div>
            <div class="login-input flex-center">
              <i>确认密码</i>
              <el-input type="password" v-model="rnewPass" placeholder="请确认密码" class="login-item"></el-input>
            </div>
          </div>

          <el-button type="primary" class="login-submit-btn" @click="setSubmit" :disabled="submitState">立即修改
          </el-button>
          <div class="gobank">
            <router-link to="/login" class="link-text">返回登录</router-link>
          </div>

        </div>

      </div>
    </div>
 <div class="footer">
      <div class=" flex-center between-box" style="height: 150px;">
        <img src="../assets/img/footerlogo.png" alt="">
        <div class="f-center">
          <p>主办单位：北京市委社会工委市民政局</p>
          <p>执行单位：北京市社会组织管理中心 </p>
          <p>协办单位：北京市扶贫协作和支援合作工作领导小组办公室 中关村科技园区管理委员会 </p>
          <p>北京市妇女联合会 北京市红十字会 首都公益慈善联合会</p>
          <p>承办单位：北京知诚社会组织众扶发展促进会</p>
        </div>
        <img src="../assets/img/ggh.png" alt="" class="ggh">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "login",
  data() {
    return {
      account: '',
      phone: '',
      smsCode: '',
      newPass: '',
      rnewPass: '',
      codeText: '获取验证码', // 验证码文字
      id: null, // 计时器id
      timeId: null, // 一次性计时器id
      submitState: false,
      dialogVisible: false
    }
  },
  methods: {
    setSubmit() {
      this.submitState = true
      if (!this.account) {
        this.$message.error('请输入帐号')
        this.submitState = false
        return
      }
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      console.log(this.phone)
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (!this.smsCode) {
        this.$message.error('请输入验证码')
        this.submitState = false
        return
      }
      if (!this.newPass) {
        this.$message.error('请输入新密码')
        this.submitState = false
        return
      }
      if (this.newPass !== this.rnewPass) {
        this.$message.error('两次密码不一致')
        this.submitState = false
        return
      }
      this.$api.apiContent.resetPass({
        user_name:this.account,
        phone: this.phone,
        code:this.smsCode,
        new_pass: this.newPass,
        rel_new_pass: this.rnewPass,
      }).then(() => {
      this.$message({
        message: '修改成功,请重新登录',
        type: 'success',
        duration: 1000
      });
      setTimeout(() => {
        this.$router.go(-1);
      }, 1500)

      }).catch(e => {
        this.$message.error(e.msg)
        this.submitState = false
      })
    },
    //  获取验证码
    sendCode() {
      if (!this.phone) {
        this.$message.error('请输入手机号')
        this.submitState = false
        return
      }
      if (this.$tools.checkTel(this.phone)) {
        this.$message.error('手机号格式错误，请确认')
        this.submitState = false
        return
      }
      if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
        this.codeText = 60
        this.id = setInterval(() => {
          if (this.codeText === 0) {
            clearInterval(this.id)
            this.codeText = '重新发送'
            return
          }
          if (typeof this.codeText === 'number') {
            this.codeText--
          }
        }, 1000)
        this.$api.apiContent.sendMsg({
          phone: this.phone
        }).then().catch(e => {
          this.$message.error(e.msg)
          this.codeText = '重新发送'
          clearInterval(this.id)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.logins-wrapper {
  width: 100%;

  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 92px;
    padding: 0 60px;
    border-bottom: 4px solid #d50000;
    .zf-logo{
      display: block;
    }
    .header-right{
      p{
        height: 32px;
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .login-box {
   width: 100%;
    min-height: 750px;
    margin: 0 auto;
    padding-top: 50px;
    background: url(../assets/img/login.jpg) no-repeat center bottom;
    background-size: 100% 100%;

    h2 {
      text-align: center;
      margin-bottom: 40px;

      img {
        display: block;
        margin: 0 auto;
      }
    }

    .login-info {
      width: 800px;
      margin: 0 auto;
      padding: 30px 50px;
      background: #fff;
      border-radius: 10px;

      .login-type {

        margin: 0 auto;

        h3 {
          display: block;
          width: 100%;
          text-align: center;
          font-size: 24px;
          line-height: 36px;
          margin-bottom: 30px;
          cursor: pointer;
          position: relative;
        }
      }


      .set-account {
        .login-input {
          height: 40px;
          border-radius: 4px;
          margin-bottom: 20px;

          i {
            display: block;
            width: 100px;
            text-align: right;
            padding-right: 15px;
          }

          .login-item {
            flex: 1;

            input {
              background: transparent;

            }
          }

          .link-text {
            display: block;
            width: 60px;
            height: 41px;
            text-align: left;
            line-height: 41px;
            background: #fff;
            margin: 0 20px;
            color: #d2151c;
          }

          .code-img {
            width: 116px;
            height: 41px;
            background: #fff;
            margin: 0 20px;
          }

          .code-text {
            width: 116px;
            height: 41px;
            text-align: center;
            line-height: 41px;
            color: #fff;
            background: #f9aa0d;
            margin: 0 20px;
            border-radius: 5px;
            cursor: pointer;
            overflow: hidden;
          }
        }
      }
      .login-submit-btn {
        display: block;
        width: 300px;
        height: 42px;
        background-color: #f9aa0d;
        border-radius: 21px;
        border: solid 1px #cccccc;
        margin: 0 auto;
      }
      .gobank{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;
        .link-text{
          color: #f9aa0d;
        }
      }
      .to-setpass {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;

        .forget {
          color: #3b77e7;
        }
      }
    }
  }
 .footer{
    min-height: 180px;
    padding: 0 80px;
    background: #333333;
    border-top: 4px solid #000;
    img{
      display: block;
      max-height: 120px;
    }
    p{
      display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 24px;
      color: #fff;
      img{
        margin-right: 5px;
      }
    }
  }
}

</style>
